import { Box, Flex } from "@chakra-ui/react"
import React, { ReactNode } from "react"

type Props = {
  children: ReactNode
  showBorder?: boolean
  noPadding?: boolean
  padding?: number
  maxWidth?: number | string
}

const PageContent = ({
  children, showBorder, noPadding, padding = 6, maxWidth = 750,
}: Props) => {
  const borderProps = showBorder ? { background: "white", borderWidth: 1, borderRadius: "md" } : {}

  return (
    <Flex
      p={noPadding ? 0 : padding}
      minHeight="full"
      minWidth={460}
      maxWidth={maxWidth}
      margin="auto"
    >
      <Flex
        p={showBorder ? 6 : 0}
        w="full"
        justifyContent="center"
        alignContent="center"
        {...borderProps}
      >
        <Box w="full">
          {children}
        </Box>
      </Flex>
    </Flex>
  )
}

export default PageContent
